export function splitStringIntoChunks(str: string, chunkSize: number) {
	const chunks = [];

	// Loop through the string and slice it into chunks of the given size
	for (let i = 0; i < str.length; i += chunkSize) {
		chunks.push(str.slice(i, i + chunkSize));
	}

	return chunks;
}
